/*
 * @Author: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @Date: 2021-01-04 14:16:46
 * @LastEditors: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @LastEditTime: 2021-03-24 11:46:46
 * @Description: 验证方法
 * @FilePath: /hsylc2021/src/utils/checkers.js
 */
import { wordLength } from './string';
const UTILS = {
  isNullOrEmpty(target) {
    let ret = true;
    if (target) {
      switch (typeof target) {
        case 'string': {
          if (target && target !== '') {
            ret = false;
          }
          break;
        }
        case 'object': {
          if (target.length) {
            ret = false;
          } else if (Object.keys(target).length) {
            ret = false;
          }
          break;
        }
        case 'number': {
          ret = false;
          break;
        }
        case 'boolean': {
          ret = !target;
          break;
        }
      }
    }
    return ret;
  },
  /**
   * @description 邮箱验证
   * @function checkEmail
   * @param {String} email email字符串
   * @return {Boolean} 是否通过校验
   */
  checkEmail(email) {
    let re = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
    return re.test(email);
  },
  /**
   * @description 检查手机
   * @function checkMobile
   * @param {String} string 手机字符串
   * @return {Boolean} 是否通过校验
   */
  checkMobile(string) {
    return /^1[3-9]\d{9}$/.test(string);
  },
  /**
   * @description 获取字符串长度
   * @function getStrLength
   * @param {String} str 需要计算长度的字符串
   * @return {Number} 字符串长度
   */
  getStrLength(str) {
    return wordLength(str);
  },

  /**
   * @description 检查是否纯数字
   * @function checkNumber
   * @param {String} number 字符串
   * @return {Boolean} 是否符合
   */
  checkNumber(number) {
    return /^[0-9]*$/.test(number);
  },
  /**
   * @description 检查 验证码 格式 4位数字
   * @function checkNumber
   * @param {*} number
   * @return {Boolean} 是否符合
   *
   */
  checkVecify(number) {
    return /^\d{4}$/.test(number);
  },
  /**
   * @description 是否符合纯英文
   * @function checkEn
   * @param {String} str 字符串
   * @return {Boolean} 是否符合
   */
  checkEn(str) {
    var re = new RegExp('^[a-zA-Z]+$');
    return re.test(str);
  },
  /**
   * @description 检查密码是否符合规则
   * @function checkPassword
   * @param {String} str 需要校验的字符串
   * @return {Boolean} 是否符合
   */
  checkPassword(str) {
    // [`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]
    let result = /^([5A-Za-z0-9-@-~!-_-$-?-=-|]{8,32})$/.test(str);
    return result;
  }
};

export default UTILS;
